"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Snackbar = {
  styles: function styles(theme) {
    return {
      root: {
        borderRadius: 8,
        minHeight: theme.spacing.base * 6
      },
      rootOpen: {
        marginTop: theme.spacing.base * 4,
        marginBottom: theme.spacing.base * 4
      },
      left: {
        insetInlineStart: theme.spacing.base * 4
      },
      right: {
        insetInlineEnd: theme.spacing.base * 4
      },
      button: {
        "& > label": {
          color: theme.colors.baseContrast090,
          fontWeight: "bold"
        },
        "&:hover, &:focus-visible": {
          background: "".concat(theme.colors.baseContrast090, "1A"),
          "& > label": {
            color: theme.colors.baseContrast090
          }
        }
      }
    };
  }
};
var _default = exports.default = Snackbar;